module.exports = __webpack_public_path__ + "img/album18_38.2ac04203.jpg";